import * as React from "react";
import { connect } from "react-redux";
import * as toastr from "toastr";

import { IOption } from "../../classes/option";
import { IState } from "../../classes/state";

import { EventView } from "./EventView";

import * as ajaxActions from "../../actions/ajaxActions";
import * as calendarSettingsActions from "../../actions/calendarSettingsActions";
import * as eventViewActions from "../../actions/eventViewActions";

import * as dates from "../../reducers/changeTimePeriod";

export class EventViewContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);

    this.requestEventsFromService();

    this.setCurrentDate = this.setCurrentDate.bind(this);
    this.setEventId = this.setEventId.bind(this);
    this.setEventScreenMode = this.setEventScreenMode.bind(this);
    this.setSelectedDate = this.setSelectedDate.bind(this);
    this.setiCalStartDate = this.setiCalStartDate.bind(this);
    this.setDisplayedEventLocalEndDate = this.setDisplayedEventLocalEndDate.bind(this);
    this.setDisplayedEventLocalStartDate = this.setDisplayedEventLocalStartDate.bind(this);
    this.setViewMode = this.setViewMode.bind(this);
    this.startAjaxCall = this.startAjaxCall.bind(this);
  }

  public requestEventsFromService() {
    this.props.requestEventsFromService(this.props.portletInstanceId, this.props.calendarId, this.props.otherCalendarIds, this.props.localFromDate, this.props.localToDate, this.props.searchFilterValue, this.props.searchText, this.props.searchCategoryValue, this.props.searchFilterOptions);
    // toastr.success("Requested events");
  }

  public setSelectedDate(event: any) {
    event.preventDefault();
    const newSelectedDate: Date = dates.parse(event.currentTarget.attributes["data-date"].value);
    this.props.setSelectedDate(newSelectedDate);
  }

  public setCurrentDate(event: any) {
    event.preventDefault();
    const newCurrentDate: Date = dates.parse(event.currentTarget.attributes["data-date"].value);
    this.props.setCurrentDate(newCurrentDate);
  }

  public setEventId(eventId: number) {
    this.props.setEventId(eventId);
  }

  public setiCalStartDate(iCalStartDate: Date) {
    this.props.setiCalStartDate(iCalStartDate);
  }

  public setDisplayedEventLocalEndDate(localEndDate: Date) {
    this.props.setDisplayedEventLocalEndDate(localEndDate);
  }

  public setDisplayedEventLocalStartDate(localStartDate: Date) {
    this.props.setDisplayedEventLocalStartDate(localStartDate);
  }

  public startAjaxCall() {
    this.props.startAjaxCall();
  }

  public setViewMode(event) {
    event.preventDefault();
    const newViewMode: string = event.currentTarget.attributes["data-value"].value;
    this.props.setViewMode(newViewMode);
  }

  public setEventScreenMode(eventScreenMode: string) {
    this.props.setEventScreenMode(eventScreenMode);
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    let wasUpdated = false;
    if (prevProps.currentDate !== this.props.currentDate) { wasUpdated = true; }
    if (prevProps.localFromDate !== this.props.localFromDate) { wasUpdated = true; }
    if (prevProps.localToDate !== this.props.localToDate) { wasUpdated = true; }
    if (prevProps.viewMode !== this.props.viewMode) { wasUpdated = true; }
    if (prevProps.searchCategoryValue !== this.props.searchCategoryValue) { wasUpdated = true; }
    if (prevProps.searchFilterValue !== this.props.searchFilterValue) { wasUpdated = true; }
    if (prevProps.searchText !== this.props.searchText) { wasUpdated = true; }
    if (prevProps.otherCalendarIds !== this.props.otherCalendarIds) { wasUpdated = true; }

    if (wasUpdated) {
      this.requestEventsFromService();
    }
  }

  public render() {

    return (
      <div>
        <EventView
          calendarId={this.props.calendarId}
          contextId={this.props.contextId}
          currentDate={this.props.currentDate}
          events={this.props.events}
          firstDayOfWeek={this.props.firstDayOfWeek}
          localToDate={this.props.localToDate}
          localFromDate={this.props.localFromDate}
          numAjaxCallsInProgress={this.props.numAjaxCallsInProgress}
          objectId={this.props.objectId}
          pageId={this.props.pageId}
          parentId={this.props.parentId}
          portalId={this.props.portalId}
          portletInstanceId={this.props.portletInstanceId}
          searchCategory={this.props.selectedSearchCategoryValue}
          searchFilter={this.props.selectedSearchFilterValue}
          searchText={this.props.searchText}
          selectedDate={this.props.selectedDate}
          text={this.props.text}
          todaysDate={this.props.todaysDate}
          userDateFormat={this.props.userDateFormat}
          viewMode={this.props.viewMode}
          width={this.props.width}
          onSetCurrentDate={this.setCurrentDate}
          onSetEventId={this.setEventId}
          onSetiCalStartDate={this.setiCalStartDate}
          onSetDisplayedEventLocalStartDate={this.setDisplayedEventLocalStartDate}
          onSetDisplayedEventLocalEndDate={this.setDisplayedEventLocalEndDate}
          onSetSelectedDate={this.setSelectedDate}
          onSetViewMode={this.setViewMode}
          onSetEventScreenMode={this.setEventScreenMode}
          onStartAjaxCall={this.startAjaxCall}
        />
        { /*
        <div>&nbsp;</div>
        <div className="modernCalendar">
          <div><b>EventViewContainer app state:</b></div>
          <div><span className="title">calendarId: </span>{this.props.calendarId}</div>
          <div>&nbsp;</div>
          <div><span className="title">searchFilterValue: </span>{this.props.searchFilterValue}</div>
          <div><span className="title">searchText: </span>{this.props.searchText}</div>
          <div><span className="title">searchCategoryValue: </span>{this.props.searchCategoryValue}</div>
          <div>&nbsp;</div>
          <div><span className="title">viewMode: </span>{this.props.viewMode}</div>
          <div><span className="title">firstDayOfWeek: </span>{this.props.firstDayOfWeek}</div>
          <div><span className="title">currentDate: </span>{this.props.currentDate.toString()}</div>
          <div><span className="title">localFromDate: </span>{this.props.localFromDate.toString()}</div>
          <div><span className="title">localToDate: </span>{this.props.localToDate.toString()}</div>
          <div>&nbsp;</div>
          {this.props.events.map((event, i) => {
            return (
              <div key={i}>
                <div><b>{event.name}</b></div>
                <div><b>EventID: {event.eventID}</b></div>
                <div>Starts: {event.localStartDate.toString()}</div>
                <div>Ends: {event.localEndDate.toString()}</div>
                <div>isAllDay: {event.isAllDay.toString()}</div>
                <div>&nbsp;</div>
              </div>
            );
          })}
        </div>
        */ }
      </div>
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    calendarId: state.calendarSettings.calendarId,
    contextId: state.calendarSettings.contextId,
    currentDate: state.calendarSettings.currentDate,
    displayedEventLocalEndDate: state.calendarSettings.displayedEventLocalEndDate,
    displayedEventLocalStartDate: state.calendarSettings.displayedEventLocalStartDate,
    events: state.events,
    firstDayOfWeek: state.calendarSettings.firstDayOfWeek,
    localFromDate: state.calendarSettings.localFromDate,
    localToDate: state.calendarSettings.localToDate,
    numAjaxCallsInProgress: state.numAjaxCallsInProgress,
    objectId: state.calendarSettings.objectId,
    otherCalendarIds: state.selectEventsFromOtherCalendarsSettings.checkedNodeCalendarIds,
    pageId: state.calendarSettings.pageId,
    parentId: state.calendarSettings.parentId,
    portalId: state.calendarSettings.portalId,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    searchCategoryValue: state.searchToolbar.selectedSearchCategoryValue,
    searchFilterOptions: state.searchToolbar.searchFilterOptions,
    searchFilterValue: state.searchToolbar.selectedSearchFilterValue,
    searchText: state.searchToolbar.searchText,
    selectedDate: state.calendarSettings.selectedDate,
    text: state.text,
    todaysDate: state.calendarSettings.todaysDate,
    userDateFormat: state.calendarSettings.userDateFormat,
    viewMode: state.calendarSettings.viewMode,
    width: state.width,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    requestEventsFromService: (portletInstanceId: number, calendarId: number, otherCalendarIds: number[], localFromDate: Date, localToDate: Date, searchFilterValue: string, searchText: string, searchCategoryValue: string, searchFilterOptions: IOption[]) => {
      const action = eventViewActions.requestEventsFromService(portletInstanceId, calendarId, otherCalendarIds, localFromDate, localToDate, searchFilterValue, searchText, searchCategoryValue, searchFilterOptions);
      dispatch(action);
    },
    setCurrentDate: (currentDate: Date) => {
      const action = calendarSettingsActions.setCurrentDate(currentDate);
      dispatch(action);
    },
    setDisplayedEventLocalEndDate: (displayedEventLocalEndDate: Date) => {
      const action = calendarSettingsActions.setDisplayedEventLocalEndDate(displayedEventLocalEndDate);
      dispatch(action);
    },
    setDisplayedEventLocalStartDate: (displayedEventLocalStartDate: Date) => {
      const action = calendarSettingsActions.setDisplayedEventLocalStartDate(displayedEventLocalStartDate);
      dispatch(action);
    },
    setEventId: (eventId: number) => {
      const action = calendarSettingsActions.setEventId(eventId);
      dispatch(action);
    },
    setEventScreenMode: (eventScreenMode: string) => {
      const action = calendarSettingsActions.setEventScreenMode(eventScreenMode);
      dispatch(action);
    },
    setSelectedDate: (selectedDate: Date) => {
      const action = calendarSettingsActions.setSelectedDate(selectedDate);
      dispatch(action);
    },
    setViewMode: (viewMode: string) => {
      const action = calendarSettingsActions.setViewMode(viewMode);
      dispatch(action);
    },
    setiCalStartDate: (iCalStartDate: Date) => {
      const action = calendarSettingsActions.setiCalStartDate(iCalStartDate);
      dispatch(action);
    },
    startAjaxCall: () => {
      const action = ajaxActions.beginAjaxCall();
      dispatch(action);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventViewContainer);
